import { withCompInfo } from '@wix/editor-elements-integrations'
import type { BackToTopButtonCss, BackToTopButtonDefinition } from './BackToTopButton'

export const css = withCompInfo<BackToTopButtonCss, BackToTopButtonDefinition>()(
	// @ts-ignore
	['compLayout', 'skin', 'compDesign', 'siteWidth', 'isOneDocMigrated'],
	// @ts-ignore
	({ compLayout, skin, compDesign, siteWidth, isOneDocMigrated }) => {
		const isLegacy = skin === 'BackToTopButtonSkin'
		const defaultSize = 44
		const position = `calc((100% - ${siteWidth}px) / 2)`
		const opacityValue = compDesign?.shapeStyle?.opacity
		const opacity = typeof opacityValue === 'number' ? opacityValue : 1
		const bottomMargin = compLayout.docked ? compLayout.docked.bottom?.px : 87
		const rightMargin = compLayout.docked ? compLayout.docked.right?.px : 0
		const leftMargin = compLayout.docked ? compLayout.docked.left?.px : 0

		return {
			'--icon-opacity': opacity,
			...(isLegacy && {
				width: `${defaultSize}px`,
				height: `${defaultSize}px`,
			}),
			...(!isOneDocMigrated && {
				position: 'fixed',
				bottom: `${bottomMargin}px`,
				...(typeof rightMargin !== 'undefined' && { 'margin-right': `${rightMargin}px`, right: position }),
				...(typeof leftMargin !== 'undefined' && { 'margin-left': `${leftMargin}px`, left: position }),
			}),
		}
	}
)
